module.exports = __webpack_public_path__ + "assets/img/carrot-hit.75cd17f3.png";